export var ViewMode;
(function (ViewMode) {
    ViewMode["box"] = "box";
    ViewMode["button"] = "button";
})(ViewMode || (ViewMode = {}));
